import Fraction from 'fraction.js';

export const FractionalNumber = {
  sumFractions(fraction1: string, fraction2: string): string {
    const isMinusFrac1 = fraction1.includes('-');
    const isMinusFrac2 = fraction2.includes('-');
    const frac1 = this.parseFraction(fraction1.replace('-', ''));
    const frac2 = this.parseFraction(fraction2.replace('-', ''));

    if (isMinusFrac1) {
      frac1['s'] = -1 * frac1['s'];
    }
    if (isMinusFrac2) {
      frac2['s'] = -1 * frac2['s'];
    }
    const result = frac1.add(frac2);
    return result.toFraction(true);
  },

  parseFraction(fractionStr: string): Fraction {
    const parts = fractionStr.split(' ');

    if (parts.length === 2) {
      const wholeNumber = parseInt(parts[0], 10);
      const fractionalPart = new Fraction(parts[1]);
      const combined = fractionalPart.add(new Fraction(wholeNumber));
      return combined;
    } else if (parts.length === 1) {
      const value = parts[0];
      if (value.includes('/')) {
        return new Fraction(value);
      } else {
        return new Fraction(parseInt(value, 10));
      }
    } else {
      throw new Error('Invalid fraction format');
    }
  },

  getFractionalNumberFromDecimal(decimal: number): string {
    if (isNaN(decimal) || !Number.isFinite(decimal)) {
      return '0';
    }
    if (Number.isInteger(decimal)) {
      return decimal.toString();
    }
    const fraction = new Fraction(decimal);
    return fraction.toFraction(true);
  },

  parseToNumber(input: string): number {
    try {
      const fraction = this.parseFraction(input);
      return fraction.valueOf();
    } catch {
      const parsed = parseFloat(input);
      if (!isNaN(parsed)) {
        return parsed;
      }
      throw new Error(`Invalid number or fraction: ${input}`);
    }
  },
};
